import { getRTEBlock } from '../../utils/RTEEditable.utils';

export const RTEElementRenderer = getRTEBlock;
